'use strict';

var App = require('app');
var AppState = require('app_state');
var LabelModel = require('models/labels');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var MultiInput = require('components/common/views/multi_input_view');
var Misc = require('utils/misc');

var GroupingDialogView = Marionette.LayoutView.extend({
    template: require('components/common/templates/grouping'),
    errors: undefined,
    events: {
        'click button#js-success': 'validateForm',
        'click a.js-add-tag': function (e) {
            e.preventDefault();
            this.publicLabelView.addItem(e.currentTarget.getAttribute('data'));
            this.refreshOnInput();
        },
        'click a.js-add-group': function (e) {
            e.preventDefault();
            this.privatLabelView.addItem(e.currentTarget.getAttribute('data'));
            this.refreshOnInput();
        },
    },
    regions: {
        privatLabels: '#privat-labels',
        publicLabels: '#public-labels',
    },

    initialize: function (options) {
        this.options = options || {};
        this.options.labels = JSON.parse(JSON.stringify(this.options.labels));
    },

    canLabelPool: function () {
        return AppState.canLabelPool() && !!this.options.labels.labelPool && !!this.options.labels.labelPool.length;
    },

    canUseOtherLabel: function () {
        return !this.canLabelPool() || AppState.isUserManagementAdmin();
    },

    getAllTags: function () {
        var useLabelPool = this.canLabelPool();
        var useOtherLabels = this.canUseOtherLabel();
        // only label pool
        if (useLabelPool && !useOtherLabels) {
            return this.options.labels.labelPool;
        }

        // used tags only
        if (!useLabelPool) {
            return this.options.labels.available.tags;
        }

        // label pool + used tags
        return _.uniq(
            Array.prototype.concat(this.options.labels.available.tags || [], this.options.labels.labelPool || [])
        );
    },

    serializeData: function () {
        var data = Misc.cloneAsJSON(this.options);

        if (this.canLabelPool() && !this.canUseOtherLabel()) {
            // restrict available labels
            data.labels.available.tags = Misc.selectWhere(data.labels.available.tags || [], function (l) {
                return data.labels.labelPool.includes(l);
            });
        }

        // filter selectable labels
        data.labels.selectable = {};
        // .. remove currently assigned tags
        data.labels.selectable.tags = _.filter(this.getAllTags(), function (e) {
            return _.indexOf(data.labels.tags, e) == -1;
        });
        // .. remove currently assigned groups
        data.labels.selectable.groups = _.filter(data.labels.available.groups, function (e) {
            return _.indexOf(data.labels.groups, e) == -1;
        });

        data.showTextLabelPool = this.canLabelPool() && !this.canUseOtherLabel();
        data.showTextTagsLabelPool = this.canLabelPool() && this.canUseOtherLabel();
        return data;
    },

    validateForm: function (e) {
        e.preventDefault();
        var self = this;

        Decorator.disableElement('.modal-dialog');

        this.options.save_cb(
            {
                groups: this.privatLabelView.getItems(),
                tags: this.publicLabelView.getItems(),
                labelPoolOnly: this.canLabelPool() && !this.canUseOtherLabel(),
            },
            function () {
                App.hideModal();
                Backbone.history.loadUrl(Backbone.history.fragment);
            },
            function (errors, data) {
                self.options.errors = errors;
                self.options.labels.tags = data.tags;
                self.options.labels.groups = data.groups;
                App.refreshModal(self);
            }
        );
    },

    onAttach: function () {
        this.initMultiInput();
    },

    onRender: function () {
        this.initMultiInput();
        this.showChildView('privatLabels', this.privatLabelView);
        this.showChildView('publicLabels', this.publicLabelView);
    },

    refreshOnInput: function () {
        if (this.privatLabelView) {
            this.options.labels.groups = this.privatLabelView.getItems();
        }
        if (this.publicLabelView) {
            this.options.labels.tags = this.publicLabelView.getItems();
        }

        this.render();
    },

    initMultiInput: function () {
        var self = this;

        this.publicLabelView = new MultiInput.View({
            delimiter: /[;,]+/,
            selectID: 'js-public-labels',
            items: Misc.selectWhere(this.options.labels.tags || [], function (tag) {
                return !self.canLabelPool() || self.canUseOtherLabel() || self.options.labels.labelPool.includes(tag);
            }),
            name: i18n.TR('Öffentlich'),
            placeholder: i18n.TR('Label hinzufügen'),
            colorClass: 'label-tags',
            readOnly: !this.canUseOtherLabel(),

            cbRemoveElement: function (e) {
                self.refreshOnInput();
            },
        });
        this.privatLabelView = new MultiInput.View({
            delimiter: /[;,]+/,
            selectID: 'js-privat-labels',
            items: this.options.labels.groups,
            name: i18n.TR('Privat'),
            placeholder: i18n.TR('Label hinzufügen'),

            cbRemoveElement: function (e) {
                self.refreshOnInput();
            },
        });
    },
});

module.exports = GroupingDialogView;
